const NAME = "MEDAL_TABLE";

export default NAME;
